import React from 'react';
import {withRouter} from 'react-router-dom';
import DropdownMenu from './DropdownMenu';

/**
 *
 */
class NavBarNav extends React.Component {
  render () {
    const items = this.props.data.map(
        (item, index) => {
          if (item.subMenu) {
            return (
              <li key={index} className="dropdown" >
                <a href={item.to}
                className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  {item.text}
                  <span className="caret"></span>
                </a>
                <DropdownMenu data={item.subMenu}/>
              </li>
            )
          } 
          return (<li key={index}><a href={item.to}>{item.text}</a></li>)
        }
    );
    return (
      <ul className={`nav navbar-nav ${this.props.className}`}>
        {items}
      </ul>
    )
  }
}

export default withRouter(NavBarNav); 



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/NavbarNav.js